import { BrowserModule } from '@angular/platform-browser';
import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { AppComponent } from './app.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { HttpClientModule } from '@angular/common/http';
import { MatDatepickerModule, DateAdapter } from '@angular/material';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { DLPRestUtilityService } from './services/rest/dlprest-utility.service';
import { AppRoutingModule } from './app-routing.module';
import { BorrowerRenderingService } from './services/borrower/borrower-rendering.service';
import { FormBuilderService } from './services/formsValidation/form-builder.service';
import { ValidationService } from './services/formsValidation/validation.service';
import { DatePipe, DecimalPipe, TitleCasePipe } from '@angular/common';
import { DateFormat } from './date-format';
import { DropdownDataService } from './services/dropdownData/dropdown-data.service';
import { DialogBoxComponent } from './otp/dialog-box/dialog-box.component'
import { OTPformBuilderService } from '../app/services/formsValidation/otpform-builder.service';
import { QuoteRenderingService } from './services/search/quote-rendering.service';
import { DlpUtilityService } from './services/utility/dlp-utility.service';
// import { LoginComponent } from './modules/login/login.component';
import { LoginRenderingService } from './services/login/login-rendering.service';
import { PrimaryFormPopulateService } from './services/form-populate/primary-form-populate/primary-form-populate.service';
import { SubmitOtpLaterComponent } from './otp/submit-otp-later/submit-otp-later.component';
import { EmailValidationDirective } from './validations/email-validation.directive';
import { MobileValidationDirective } from './validations/mobile-validation.directive';
import { RadioThreeButtonComponent } from './customControls/radio-three-button/radio-three-button.component';
import { AuthorisationService } from './services/authorisation/authorisation.service';
import { CacheMapService } from './services/caching/cache-map.service'
import { AuthGuardService } from './services/auth-guard/auth-guard.service';
import { ErrorsComponent } from './customControls/errors/errors.component';
import { HomeModalComponent } from './home-modal/home-modal.component';
import { NameValidationDirective } from './validations/name-validation.directive';
import { ApiService } from './services/api/api.service';
import { httpInterceptorProviders } from './helpers/httpInterceptorProviders ';
import { Cache } from './helpers/cache';
// import { BankDetailsComponent } from './form2/forms/bank-details/bank-details.component';
import { MyRecentActivitesComponent } from './recent-activites/my-recent-activites/my-recent-activites.component';
import { NotificationComponent } from './notification/notification.component';
import { EmiErrorComponent } from './snack-bar/emi-error/emi-error.component';
import { HomeComponent } from './reports/home/home.component';
import { DateValidationDirective } from './validations/date-validation.directive';
import { ToDateValidationDirective } from './validations/to-date-validation.directive';
import { BsDropdownModule } from 'ngx-bootstrap';
import { PreApprovalNotificationComponent } from './notification/pre-approval-notification/pre-approval-notification.component';
import { OnlineCustomerNotificationComponent } from './notification/online-customer-notification/online-customer-notification.component';
import { BroadcastMessageComponent } from './notification/broadcast-message/broadcast-message.component';
// import { AadharValidationDirective } from './validations/aadhar-validation.directive';
import { MaterialModuleModule } from './modules/material-module/material-module.module';
import { LogoutModalComponent } from './logout/logout-modal/logout-modal.component';
import { OnLogoutComponent } from './logout/on-logout/on-logout.component';
import { ErrorMainComponent } from './error-components/error/error.component';
import { HeaderFooterModuleModule } from './modules/header-footer-module/header-footer-module.module';
import { SharedComponentsModule } from './modules/shared-components/shared-components.module';
import { BroadcastSearchControllerService } from './rest-proxy/api/api';
import { FaqComponent, viewFAQ } from './faq/faq.component';
import { FaqControllerService } from './rest-proxy/api/faqController.service';
// import { WebSocketService } from './websocket.service';
// ag-grid
import { AgGridModule } from 'ag-grid-angular';
import { NO_ERRORS_SCHEMA } from '@angular/core';
import { DownpaymentValidationDirective } from './validations/downpayment-validation.directive';
import { PagenotfoundComponent } from './pagenotfound/pagenotfound.component';
import { ImageViewComponent } from './document-view/image-view/image-view.component';
import { PdfViewComponent } from './document-view/pdf-view/pdf-view.component';
import { InactivityService } from './services/utility/idle-session-expiry-service';
import { RecaptchaFormsModule, RecaptchaModule } from 'ng-recaptcha';

@NgModule({
  declarations: [
    AppComponent,
    DialogBoxComponent,
    // LoginComponent,
    SubmitOtpLaterComponent,
    EmailValidationDirective,
    MobileValidationDirective,
    RadioThreeButtonComponent,
    ErrorsComponent,
    HomeModalComponent,
    LogoutModalComponent,
    NameValidationDirective,
    OnLogoutComponent,
    MyRecentActivitesComponent,
    NotificationComponent,
    EmiErrorComponent,
    HomeComponent,
    DateValidationDirective,
    ToDateValidationDirective,
    PreApprovalNotificationComponent,
    OnlineCustomerNotificationComponent,
    BroadcastMessageComponent,
    OnLogoutComponent,
    ErrorMainComponent,
    FaqComponent,
    viewFAQ,
    DownpaymentValidationDirective,
    PagenotfoundComponent,
    ImageViewComponent,
    PdfViewComponent,
    
  ],
  imports: [
    AgGridModule.withComponents(null),
    BrowserModule,
    FormsModule,
    ReactiveFormsModule,
    HttpClientModule,
    BrowserAnimationsModule,
    AppRoutingModule,
    BsDropdownModule.forRoot(),
    MaterialModuleModule,// also contains ngx loader
    HeaderFooterModuleModule,// for drag and drop
    RecaptchaModule.forRoot(),
    RecaptchaFormsModule
   
  ],
  providers: [
    MatDatepickerModule,
    DLPRestUtilityService,
    BorrowerRenderingService,
    QuoteRenderingService,
    FormBuilderService,
    DropdownDataService,
    ValidationService,
    DatePipe,
    DecimalPipe,
    OTPformBuilderService,
    DlpUtilityService,
    LoginRenderingService,
    PrimaryFormPopulateService,
    AuthorisationService,
    CacheMapService,
    AuthGuardService,
    ApiService,
    httpInterceptorProviders,
    TitleCasePipe,
    { provide: Cache, useClass: CacheMapService },
    { provide: DateAdapter, useClass: DateFormat },
    BroadcastSearchControllerService,
    FaqControllerService,
    InactivityService,
   
   
    
    // WebSocketService
  ],
  bootstrap: [AppComponent],
  schemas: [NO_ERRORS_SCHEMA, CUSTOM_ELEMENTS_SCHEMA],
  entryComponents: [DialogBoxComponent, HomeModalComponent, LogoutModalComponent, EmiErrorComponent, viewFAQ, ImageViewComponent, PdfViewComponent]
})
export class AppModule {
  constructor(private dateAdapter: DateAdapter<Date>) {
    this.dateAdapter.setLocale('en-in'); // DD/MM/YYYY
  }
}
